import React from 'react';
import { useTheme } from '../context/ThemeContext';

export const ScrollbarStyle = () => {
  const { theme } = useTheme();

  return (
    <style>
      {`
        /* Width */
        ::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          @apply ${theme === 'light' ? 'bg-gray-100' : 'bg-gray-800'} rounded-lg;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          @apply ${theme === 'light' ? 'bg-gray-300 hover:bg-gray-400' : 'bg-gray-600 hover:bg-gray-500'} rounded-lg transition-colors;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          @apply ${theme === 'light' ? 'bg-gray-400' : 'bg-gray-500'};
        }

        /* For Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${theme === 'light' ? '#D1D5DB #F3F4F6' : '#4B5563 #1F2937'};
        }
      `}
    </style>
  );
};
